import PropTypes from 'prop-types';
import React from 'react';
import { eventPropTypesShape } from '../../Includes/eventsProps';
import Button from '../../Input/Button/Button';
import ListSection from '../../Layout/ListSection/ListSection';
import SingleEventComponent from '../EventList/SingleEventComponent/SingleEventComponent';

import './UpcomingEvents.scss';

export default class UpcomingEvents extends React.PureComponent {
    render() {
        const { events } = this.props;
        const eventList = events.map((event) => (
            <SingleEventComponent
                key={event.id}
                event={event}
                userRegistered={event.userRegistered}
                cardStyling={false}
                compactSize
            />
        ));

        const zeroState = <span>There are currently no upcoming events.</span>;

        return (
            <div className="component-Events-UpcomingEvents">
                <ListSection title="Upcoming Event">
                    {eventList.length === 0 ? zeroState : eventList}
                </ListSection>
                <div className="see-all-section">
                    <a href="/events" className="button-wrapper">
                        <Button
                            type="solid-wired-blue"
                            value="See all events"
                            inputStyle="all-event-btn"
                        />
                    </a>
                </div>
            </div>
        );
    }
}

UpcomingEvents.propTypes = {
    /**
     * list of 3 or fewer upcoming events
     */
    events: PropTypes.arrayOf(eventPropTypesShape),
};

UpcomingEvents.defaultProps = {
    events: [],
};
